import { ChangeDetectionStrategy, Component, EventEmitter, Output, ViewChild } from '@angular/core'
import { InvisibleReCaptchaComponent, NgxCaptchaModule } from 'ngx-captcha'

import { environment } from 'apps/gb-front/src/environments/environment'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'gb-front-invisible-recaptcha',
  templateUrl: './gb-front-invisible-recaptcha.component.html',
  styleUrls: ['./gb-front-invisible-recaptcha.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgxCaptchaModule, FormsModule],
})
export class GbFrontInvisibleRecaptchaComponent {
  @ViewChild('captchaElem') captchaElem!: InvisibleReCaptchaComponent
  @Output() recaptchaSuccess: EventEmitter<string> = new EventEmitter<string>()

  recaptchaSiteKey = environment.recaptchaSiteKey
  recaptcha: any = null

  execute(): void {
    this.captchaElem.execute()
  }

  reset(): void {
    this.captchaElem.resetCaptcha()
  }

  onRecaptchaSuccess(captchaResponse: string): void {
    this.recaptchaSuccess.emit(captchaResponse)
  }
}
